document.addEventListener('DOMContentLoaded', () => {
    location.hash && scrollTo(getScrollEl());
});
window.addEventListener('hashchange', () => {
    scrollTo(getScrollEl());
});

function scrollTo(element) {
    setTimeout(() => {
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: element.offsetTop - 75,
        });
    }, 1000);

    element.style.backgroundColor = '#aaa';
    setTimeout(() => {
        element.style.backgroundColor = 'unset';
    }, 1500);
}

function getScrollEl() {
    switch (location.hash) {
        case '#location':
            return document.getElementById('location-heading');
        case '#facilities':
            return document.getElementById('facilities-heading');
        case '#visibility':
            return document.getElementById('visibility-heading');
        case '#diversified-customers':
            return document.getElementById('diversified-customers-heading');
        case '#accessibility':
            return document.getElementById('accessibility-heading');
        case '#wide-choice':
            return document.getElementById('wide-choice-heading');
        case '#functional-zoning':
            return document.getElementById('functional-zoning-heading');
        default:
            break;
    }
}
